/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPINDUSTRY } from './IAPINDUSTRY';
import {
    IAPINDUSTRYFromJSON,
    IAPINDUSTRYFromJSONTyped,
    IAPINDUSTRYToJSON,
} from './IAPINDUSTRY';
import type { IAPINDUSTRYSECTOR } from './IAPINDUSTRYSECTOR';
import {
    IAPINDUSTRYSECTORFromJSON,
    IAPINDUSTRYSECTORFromJSONTyped,
    IAPINDUSTRYSECTORToJSON,
} from './IAPINDUSTRYSECTOR';
import type { IAPORGANISATIONCLASSIFICATION } from './IAPORGANISATIONCLASSIFICATION';
import {
    IAPORGANISATIONCLASSIFICATIONFromJSON,
    IAPORGANISATIONCLASSIFICATIONFromJSONTyped,
    IAPORGANISATIONCLASSIFICATIONToJSON,
} from './IAPORGANISATIONCLASSIFICATION';
import type { IAPORGANISATIONSUBCLASSIFICATION } from './IAPORGANISATIONSUBCLASSIFICATION';
import {
    IAPORGANISATIONSUBCLASSIFICATIONFromJSON,
    IAPORGANISATIONSUBCLASSIFICATIONFromJSONTyped,
    IAPORGANISATIONSUBCLASSIFICATIONToJSON,
} from './IAPORGANISATIONSUBCLASSIFICATION';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface ThirdPartyOrganisationFinancialAndTax
 */
export interface ThirdPartyOrganisationFinancialAndTax {
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof ThirdPartyOrganisationFinancialAndTax
     */
    isUSCitizen?: IAPYESORNO;
    /**
     * 
     * @type {IAPORGANISATIONCLASSIFICATION}
     * @memberof ThirdPartyOrganisationFinancialAndTax
     */
    organisationClassificationId?: IAPORGANISATIONCLASSIFICATION;
    /**
     * 
     * @type {IAPORGANISATIONSUBCLASSIFICATION}
     * @memberof ThirdPartyOrganisationFinancialAndTax
     */
    organisationSubClassificationId?: IAPORGANISATIONSUBCLASSIFICATION;
    /**
     * 
     * @type {string}
     * @memberof ThirdPartyOrganisationFinancialAndTax
     */
    giiNumber?: string;
    /**
     * 
     * @type {IAPINDUSTRYSECTOR}
     * @memberof ThirdPartyOrganisationFinancialAndTax
     */
    industrySector?: IAPINDUSTRYSECTOR;
    /**
     * 
     * @type {IAPINDUSTRY}
     * @memberof ThirdPartyOrganisationFinancialAndTax
     */
    industry?: IAPINDUSTRY;
    /**
     * 
     * @type {string}
     * @memberof ThirdPartyOrganisationFinancialAndTax
     */
    otherIndustrySectorName?: string;
}

/**
 * Check if a given object implements the ThirdPartyOrganisationFinancialAndTax interface.
 */
export function instanceOfThirdPartyOrganisationFinancialAndTax(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ThirdPartyOrganisationFinancialAndTaxFromJSON(json: any): ThirdPartyOrganisationFinancialAndTax {
    return ThirdPartyOrganisationFinancialAndTaxFromJSONTyped(json, false);
}

export function ThirdPartyOrganisationFinancialAndTaxFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThirdPartyOrganisationFinancialAndTax {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isUSCitizen': !exists(json, 'IsUSCitizen') ? undefined : IAPYESORNOFromJSON(json['IsUSCitizen']),
        'organisationClassificationId': !exists(json, 'OrganisationClassificationId') ? undefined : IAPORGANISATIONCLASSIFICATIONFromJSON(json['OrganisationClassificationId']),
        'organisationSubClassificationId': !exists(json, 'OrganisationSubClassificationId') ? undefined : IAPORGANISATIONSUBCLASSIFICATIONFromJSON(json['OrganisationSubClassificationId']),
        'giiNumber': !exists(json, 'GiiNumber') ? undefined : json['GiiNumber'],
        'industrySector': !exists(json, 'IndustrySector') ? undefined : IAPINDUSTRYSECTORFromJSON(json['IndustrySector']),
        'industry': !exists(json, 'Industry') ? undefined : IAPINDUSTRYFromJSON(json['Industry']),
        'otherIndustrySectorName': !exists(json, 'OtherIndustrySectorName') ? undefined : json['OtherIndustrySectorName'],
    };
}

export function ThirdPartyOrganisationFinancialAndTaxToJSON(value?: ThirdPartyOrganisationFinancialAndTax | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IsUSCitizen': IAPYESORNOToJSON(value.isUSCitizen),
        'OrganisationClassificationId': IAPORGANISATIONCLASSIFICATIONToJSON(value.organisationClassificationId),
        'OrganisationSubClassificationId': IAPORGANISATIONSUBCLASSIFICATIONToJSON(value.organisationSubClassificationId),
        'GiiNumber': value.giiNumber,
        'IndustrySector': IAPINDUSTRYSECTORToJSON(value.industrySector),
        'Industry': IAPINDUSTRYToJSON(value.industry),
        'OtherIndustrySectorName': value.otherIndustrySectorName,
    };
}

